import ethereum from 'decentralized/ethereum.js';
import GuildSamples from 'decentralized/guilds/GuildSamples.js';
import BackendQuery from 'decentralized/BackendQuery.js';
import {NewDiscogsSample} from 'decentralized/EthereumEvents.js';
import {SampleTagged} from 'decentralized/EthereumEvents.js';
import {SampleStyle} from 'decentralized/EthereumEvents.js';
import {SampleYear} from 'decentralized/EthereumEvents.js';
import {SampleCountry} from 'decentralized/EthereumEvents.js';
import {SampleYoutube} from 'decentralized/EthereumEvents.js';
import {SequenceCreated} from 'decentralized/EthereumEvents.js';
import {SampleCreated} from 'decentralized/EthereumEvents.js';
import GuildSamplesContract from 'decentralized/contracts/GuildSamplesContract.js';

const contract = new GuildSamplesContract();

const searchCaches = {};

export const getSoundsWithDiscogs = async (discogsId) => {
    return await getSoundsWithField(NewDiscogsSample, 'discogsId', discogsId, 'sampleHash');
};

export const getSoundsWithTag = async (tag) => {
    return await getSoundsWithField(SampleTagged, 'tag', tag);
};

export const getSoundsWithVideo = async (videoId) => {
    return await getSoundsWithField(SampleYoutube, 'videoId', videoId);
};

export const getSoundsWithUserBlockNumber = async (user, blockNumber) => {
    let key = SampleCreated + user + blockNumber;
    if (searchCaches[key]) {
        return searchCaches[key];
    }

    let query = new BackendQuery(contract.contractAddress)
        .from(SampleCreated)
        .select('ipfsHash')
        .where('user', user)
        .fromBlock(blockNumber)
        .toBlock(blockNumber)
        .whereIn('guildId', await getGuildsWithAccess());
    
    let results = await query.executeQuery(true);
    searchCaches[key] = Array.from(new Set(results.map(x => x.ipfsHash)));
    return searchCaches[key];
}


export const getGuildsWithAccess = async () => {
    let guilds = [... await ethereum.guilds.getGuildsWithAccess()];
    guilds.reverse();
    for (let i in guilds) {
        if (i >= 1) {
            break;
        }
        await ethereum.guilds.getGuildKey(guilds[i]);
    }
    guilds = [guilds[0]];
    return [... guilds, 0];
}

const getCachedResult = (event, fieldType, field) => {
    let key = event + fieldType + field;
    return searchCaches[key];
};

const cacheResult = (event, fieldType, field, data) => {
    let key = event + fieldType + field;
    searchCaches[key] = data;
}

const getSoundsWithField = async (event, fieldType, field, sampleField='ipfsHash') => {
    if (getCachedResult(event, fieldType, field)) {
        return getCachedResult(event, fieldType, field);
    }

    let guilds = await getGuildsWithAccess();
    let results = await new BackendQuery(contract.contractAddress)
        .from(event)
        .select(sampleField)
        .whereIn("guildId", guilds)
        .where(fieldType, field)
        .executeQuery();

    let data = Array.from(new Set(results.map(x => x[sampleField])));
    cacheResult(event, fieldType, field, data);
    return data;
};

    

export const getTitlesForSounds = async (sounds) => {
    let results = await new BackendQuery(contract.contractAddress)
        .from(SampleCreated)
        .select("title")
        .select("ipfsHash")
        .whereIn("ipfsHash", sounds)
        .executeQuery();

    return results;
};
